module.exports = __webpack_public_path__ + "static/media/pernambuco.f76aac1e.png";